import { createContext } from 'react';
import type { PlatformBranding } from '@/types';

export interface TenantPublicPresentation {
  name?:string; identifier?:string; enabledModules?:string[]; phonePrefix?:string|null;
  branding?:{website?:PlatformBranding;providerApp?:PlatformBranding};
}
export const TenantPresentationContext=createContext<TenantPublicPresentation|null>(null);
const EMPTY_ICON='data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg"/%3E';
export function applyTenantDocumentBranding(branding:PlatformBranding|undefined,name:string|undefined,language:string){
 const localized=language.startsWith('ar')?branding?.appNameArabic||branding?.appName:branding?.appName||branding?.appNameArabic;
 document.title=localized||name||'';
 const icon=branding?.faviconUrl||branding?.appIconUrl||branding?.logoUrl||EMPTY_ICON;
 // Remove the platform icon rather than leaving competing icon candidates.
 document.querySelectorAll('link[rel="icon"],link[rel="shortcut icon"],link[rel="apple-touch-icon"]').forEach(link=>link.remove());
 for(const rel of ['icon','apple-touch-icon']){const link=document.createElement('link');link.rel=rel;link.href=icon;link.dataset.tenantBrand='true';document.head.appendChild(link);}
}
